import React from 'react';
import { ClockIcon, CheckIcon, GlobeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { incluyeOferta } from '../data/content';
export function Pricing() {
  return <section id="precio" className="w-full bg-white" aria-labelledby="precio-titulo" data-id="element-106" data-mp="2oi7fvhjl3my0">
      <div className="mx-auto max-w-3xl px-5 py-10 sm:px-6 sm:py-16" data-id="element-107" data-mp="2jknu7wkk47w1">
        <h2 id="precio-titulo" className="font-display text-center text-[1.6rem] leading-[1.05] text-ink-strong sm:text-4xl" data-id="element-108" data-mp="1vtib98jbkzhi">
          Ordena tu Airbnb hoy y empieza a aplicar el sistema en minutos
        </h2>

        <div className="mt-6 rounded-2xl border-2 border-brand bg-white p-5 shadow-price sm:p-8" data-id="element-109" data-mp="25tsouu99o8x7">
          <div className="hidden flex-wrap items-center justify-center gap-x-3 gap-y-2 sm:flex sm:justify-between" data-id="element-110" data-mp="20rjvhwshf4uk">
            <p className="inline-flex items-center gap-1.5 text-[11px] font-extrabold uppercase tracking-wide text-brand-dark" data-id="element-111" data-mp="3h9hejtdwnm1p">
              <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-112" data-mp="3vzp5xj5hic9j" />
              El precio de lanzamiento cierra en
            </p>
            <Countdown seconds={3 * 3600 + 4 * 60 + 46} compact data-id="element-113" data-mp="4s4c9dce4viy" />
          </div>

          <div className="text-center sm:mt-5 sm:border-t sm:border-surface-line sm:pt-5" data-id="element-114" data-mp="9rz17bclvb1d">
            <p className="font-display text-lg leading-tight text-ink-strong sm:text-2xl" data-id="element-115" data-mp="erv6ddx1h8ii">
              ANFITRIÓN PRO 365™
            </p>
            <p className="mt-3 text-sm font-semibold text-ink-muted" data-id="element-116" data-mp="3dailnrp1lclm">
              Precio original:{' '}
              <span className="line-through decoration-brand decoration-2" data-id="element-117" data-mp="3i8bpie2vhuiq">
                USD $192
              </span>
            </p>
            <p className="mt-1 flex items-baseline justify-center gap-2" data-id="element-118" data-mp="3rxlgtrpw795s">
              <span className="font-display text-5xl leading-none tracking-tight text-ink-strong sm:text-6xl" data-id="element-119" data-mp="3rzy9ayta11x3">
                $14.99
              </span>
              <span className="font-display text-xl leading-none text-ink-muted" data-id="element-120" data-mp="2zgiw4ijw67ah">
                USD
              </span>
            </p>
            <p className="mx-auto mt-3 inline-flex items-center gap-1.5 rounded-full border border-success-border bg-success-soft px-3 py-1.5 text-xs font-bold text-success" data-id="element-121" data-mp="2res0i3enaqwc">
              <GlobeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-122" data-mp="315czhry8dxfs" />
              Pagás en tu moneda local
            </p>

            <div className="mx-auto mt-5 max-w-sm" data-id="element-123" data-mp="2w9o480t8v2pa">
              <CTAButton label="Quiero mi Airbnb ordenado" size="lg" fullWidth href="https://anfitrionpro365.impultienda.ar/checkout" data-id="element-124" data-mp="28h7dz2zcs4ew" />
            </div>
            <p className="mt-3 text-[11px] font-semibold leading-snug text-ink-muted sm:text-xs" data-id="element-125" data-mp="2ihhpmj5qp3ry">
              Pago único · Sin suscripciones · Acceso inmediato · Pagas en tu
              moneda local
            </p>
          </div>

          <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2 border-t border-surface-line pt-5" data-id="element-126" data-mp="3ow8vl19pzesu">
            {incluyeOferta.map(item => <li key={item} className="flex items-start gap-2" data-id="element-127" data-mp="9m0obr0ji81">
                <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-128" data-mp="596widavzagj" />
                <span className="text-[12px] font-medium leading-snug text-ink sm:text-sm" data-id="element-129" data-mp="3rgot16il7uju">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}